<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-团队业绩-业绩列表
      -->

  <div class="user">
    <div class="pb50">
      <!--内容-->
      <div class="product-content">
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">结算单号：</span>
                {{ detail.statement_no }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">返利总额：</span>
                {{ detail.total_rebate }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">代理人数：</span>
                {{ detail.total_user }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">结算月份：</span>
                {{ detail.log_time }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">业绩结算类型：</span>
                 <span class="red" v-if="detail.award_type == 0">按照销售额</span>
                <span class="blue" v-if="detail.award_type == 1">按照销量</span>
              </div>
            </el-col>
            <el-col :span="5" v-if="detail['status'] == 0" v-auth="'/plus/groupaward/statement/confirm'">
              <el-button @click="confirmClick(detail, 'edit')" size="small">确认结算单</el-button>
            </el-col>
            <el-col :span="5" v-if="detail['status'] == 1" v-auth="'/plus/groupaward/statement/sendRebate'">
              <el-button @click="sendClick(detail, 'edit')" size="small">发放业绩奖励</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">

        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.keyword" placeholder="请输入会员ID查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="nickName" label="会员">
              <template slot-scope="scope">
                <p >会员ID:{{scope.row.user_id}}</p>
                <p >昵称:{{scope.row.user.nickName}}</p>
              </template>
            </el-table-column>
            <el-table-column prop="total_performance" label="销售业绩（金额）"></el-table-column>
            <el-table-column prop="total_num" label="销量（总产品销量）"></el-table-column>
            <el-table-column prop="awart_type" label="业绩结算类型">
               <template slot-scope="scope">
                  <span class="red" v-if="scope.row.award_type == 0">按照销售额</span>
                <span class="blue" v-if="scope.row.award_type == 1">按照销量</span>
              </template>
            </el-table-column>
            <el-table-column prop="awardRate" label="返利比例">
                <template slot-scope="scope">
                  <span  v-if="scope.row.award_type == 0">{{scope.row.awardRate}} %</span>
                  <span  v-if="scope.row.award_type == 1">{{scope.row.awardRate}} 元/件</span>
              </template>
            </el-table-column>
            <el-table-column prop="total_rebate" label="团队返利总额" ></el-table-column>
            <el-table-column prop="real_rebate" label="个人返利金额" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
      <!--操作-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">返回</el-button>
      
      </div>
    </div>
  </div>
</template>

<script>
  import GroupAwardApi from '@/api/groupaward.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {
          id: 0,
          keyword: ''
        },
        detail: [],
        status: ['未开始', '进行中', '已结束'],
        file:{},
      };
    },
    created() {
      this.formInline.id = this.$route.query.id;
      /*获取结算单*/
      this.getStatement();
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      getStatement(){
        let self = this;
        let id = self.formInline.id;
        GroupAwardApi.getStatement({id:id}, true)
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        GroupAwardApi.getStatementLogList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      confirmClick(){
        let self = this;
        let id = self.formInline.id;
        self.loading = true;
        GroupAwardApi.confirmStatement({id:id}, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '结算单已确认，请结算奖励',
              type: 'success'
            });
            self.getStatement();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      sendClick(){
        let self = this;
        let id = self.formInline.id;
        self.loading = true;
        GroupAwardApi.sendStatement({id:id}, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '收益已发放成功！',
              type: 'success'
            });
            self.getStatement();
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      /*取消*/
      cancelFunc() {
        /*存储缓存*/
        localStorage.setItem('activeName','second')
        this.$router.back(-1);
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/statement/detail.vue